// extracted by mini-css-extract-plugin
export default {"legendUl":"MyCharts_legendUl__purKY","legendLabel":"MyCharts_legendLabel__orYck"};